'use client';
import { useEffect } from 'react';
import { IoLogoInstagram, IoLogoFacebook, IoLogoYoutube } from 'react-icons/io';
import { Metadata } from 'next';
import * as stylex from '@stylexjs/stylex';
import { colors } from '@/common/tokens.stylex';

export const metadata: Metadata = {
  title: 'Fehler aufgetreten',
};

export default function Error({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  useEffect(() => {
    import('../common/bugsnack').then((bugsnack) => {
      bugsnack.default.notify(error);
    });
  }, [error]);

  return (
    <>
      <h1 {...stylex.props(styles.heading)}>
        Ohhhh, es ist ein Fehler aufgetreten
      </h1>
      <p {...stylex.props(styles.copy)}>
        Mach dir keine Sorgen, du kannst mit einem Klick zurück zur{' '}
        <a href="/" title="Zur Startseite">
          Startseite
        </a>{' '}
        gelangen.
      </p>
      <p {...stylex.props(styles.copy, styles.retry)}>
        <button onClick={() => reset()}>Try again</button>
      </p>
      <div {...stylex.props(styles.socials)}>
        <a
          href="https://www.instagram.com/promiflash/"
          target="_blank"
          rel="noreferrer"
          title="Unser Instagram"
        >
          <IoLogoInstagram size={55}></IoLogoInstagram>
        </a>
        <a
          href="https://www.facebook.com/Promiflash/"
          target="_blank"
          rel="noreferrer"
          title="Unser Facebook"
        >
          <IoLogoFacebook size={55}></IoLogoFacebook>
        </a>
        <a
          href="https://www.youtube.com/user/PromiFlash"
          target="_blank"
          rel="noreferrer"
          title="Unser Youtube"
        >
          <IoLogoYoutube size={55}></IoLogoYoutube>
        </a>
      </div>
      <div {...stylex.props(styles.videoWrap)}>
        <iframe
          {...stylex.props(styles.iframe)}
          width="100%"
          height="100%"
          src="https://www.youtube.com/embed/videoseries?list=UUFVY0654zQ6DVFAHspGiOwg"
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
        ></iframe>
      </div>
    </>
  );
}

const styles = stylex.create({
  heading: {
    textAlign: 'center',
    margin: 20,
  },
  copy: {
    margin: 20,
    textAlign: 'center',
  },
  retry: {
    color: {
      ['@media (prefers-color-scheme: dark)']: colors.lighterGrey,
    },
    paddingBottom: {
      ['@media (prefers-color-scheme: dark)']: 20,
    },
  },
  socials: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: 24,
  },
  videoWrap: {
    paddingTop: '56.25%',
    width: '100%',
    position: 'relative',
  },
  iframe: {
    position: 'absolute',
    top: 0,
  },
});
